import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  rootUri = environment.root_uri;

  constructor(
    private http: HttpClient
  ) { }

  getUserStats() {
    return this.http.get(this.rootUri + "/api/host/stats");
  }

  getUserVenues() {
    return this.http.get(this.rootUri + "/api/host/venues");
  }
}
